import * as Sentry from '@sentry/browser';

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

Sentry.init({ 
  dsn: sentryDsn,
  release: process.env.REACT_APP_SENTRY_RELEASE,
});
export {Sentry}
